
// 
// 描述： 造价文件接口
// 时间： 2020 / 5 / 20
// created by zjj
// 
import request from '../request.js'

//造价文件-新增文件-点击保存按钮上传xml 时的预览接口 李开明
const getXmlview = function (data, progressFn, index) {
    return request({
        url: 'busCostDetail/analysisFile',
        method: 'post',
        config: {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        },
        onUploadProgress: function (progressEvent) {
            if (progressFn) {
                progressFn(progressEvent, index)
            }
        },
        data
    })
}
const getDictsByValue = function (data) {  //码表 李开明
    return request({
        url: 'sysDict/getDictsByValue',
        method: 'post',
        data
    })
}

// 造价文件 xml 解析自动匹配单位工程 --- 郑志会
const matchUnit = function (data) {
    return request({
        url: 'busCostDetail/automaticMatchingUnitId',
        method: 'post',
        data
    })
}

// 签证 xml 解析自动匹配单位工程 --- 郑志会
const matchVisaUnit = function (data) {
    return request({
        url: 'visaCostDetail/automaticMatchingUnitId',
        method: 'post',
        data
    })
}

//造价文件-选择xml文件点击确定跳转页面中单位工程的下拉列表接口 李开明
const selectDanWeiByProject = function (data) {
    return request({
        url: 'busCostDetail/selectDanWeiByProject',
        method: 'post',
        data
    })
}
//造价文件-选择xml文件点击确定跳转页面后，单击单位工程下拉列表判断该单位工 李开明
const judgeDanweiIsData = function (data) {
    return request({
        url: 'busCostDetail/judgeDanweiIsData',
        method: 'post',
        data
    })
}
//造价文件-获取项目结构树以及单位工程对应的概算信息 王开国
const getProjectBudgets = function (data) {
    return request({
        url: 'busProContract/getProjectBudgets',
        method: 'post',
        data
    })
}
//造价文件-查询指定项目的预算其他费用或预备费用的列表
const selectBudgetOtherList = function (data) {
    return request({
        url: 'busCostBudgetOther/selectBudgetOtherList',
        method: 'post',
        data
    })
}

//保存 李开明
const costSave = function (data) {
    return request({
        url: 'busCostDetail/costSave',
        method: 'post',
        data
    })
}
//造价文件 列表
const selectCostPage = function (data) {
    return request({
        url: 'busCostDetail/selectCostPage',
        method: 'post',
        data
    })
}
//删除
const deleteCostDetail = function (data) {
    return request({
        url: 'busCostDetail/deleteCostDetail',
        method: 'post',
        data
    })
}
//造价文件-点击概算价进入跳转页面-右边模块的保存
const saveCostBudgetDetail = function (data) {
    return request({
        url: 'busProContract/saveCostBudgetDetail',
        method: 'post',
        data
    })
}
//造价文件-删除其他费用和预备费
const deleteOtherCost = function (data) {
    return request({
        url: 'busProContract/deleteOtherCost',
        method: 'post',
        data
    })
}
//造价文件-选择概算价跳转页面进入回显概算价信息 李开明
const costEcho = function (data) {
    return request({
        url: 'analysisFormTemplate/costEcho',
        method: 'post',
        data
    })
}
//保存六算基本信息动态表单字段值 李开明
const budgetPriceSave = function (data) {
    return request({
        url: 'basicInfoProject/budgetPriceSave',
        method: 'post',
        data
    })
}

export {
    getXmlview,
    getDictsByValue,
    selectDanWeiByProject,
    judgeDanweiIsData,
    getProjectBudgets,
    selectBudgetOtherList,
    costSave,
    selectCostPage,
    deleteCostDetail,
    saveCostBudgetDetail,
    deleteOtherCost,
    costEcho,
    budgetPriceSave,
    matchUnit,
    matchVisaUnit
}